import { ranks } from '../style';

export const RANK_PRIMARY = Symbol('RANK_PRIMARY');
export const RANK_SECONDARY = Symbol('RANK_SECONDARY');
export const RANK_TERTIARY = Symbol('RANK_TERTIARY');
export const RANK_TEXT = Symbol('RANK_TEXT');
export const RANK_TEXT_REGULAR = Symbol('RANK_TEXT_REGULAR');

export function getRankData(rank) {
  switch (rank) {
    case RANK_PRIMARY:
      return ranks.primary;
    case RANK_SECONDARY:
      return ranks.secondary;
    case RANK_TERTIARY:
      return ranks.tertiary;
    case RANK_TEXT:
      return ranks.text;
    case RANK_TEXT_REGULAR:
      return ranks.textRegular;
    default:
      throw new Error(`Unknown rank ${String(rank)}`);
  }
}

export default [
  RANK_PRIMARY,
  RANK_SECONDARY,
  RANK_TERTIARY,
  RANK_TEXT,
  RANK_TEXT_REGULAR,
];
